import { styled, Tabs } from '@mui/material';

export const StyledTabs = styled(Tabs)`
  .MuiButtonBase-root {
    display: flex;
    flex-direction: row;
    min-height: 15px;
    padding-bottom: 4px;
  }
`;

export const StyledInput = styled('input')({
  display: 'none',
});